import { TextField, Typography, styled } from '@mui/material';

export const StyledFieldLabel = styled(Typography)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  textAlign: 'left',
  marginBottom: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)({
  width: '100%',
});

export const StyledCharacterCount = styled(Typography)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  textAlign: 'right',
  marginTop: theme.spacing(0.5),
  color: '#666',
}));
